// The site map both footers read (SiteFooter on reference pages, DesertFooter's
// full form on inner Desert Book pages): one list, so the two never drift.
// Each column keeps at most six top-level entries; a group shows only its hub
// link (Chris, 2026-10-27). No page counts: the children here are a hand-kept
// sample, not the hub's contents, so a count would drift.

/* ── Site map columns ─────────────────────────────────── */

export type SiteMapLink = {
  label: string;
  href: string;
  external?: boolean;
  /** Second-level pages, kept for reference. Footers do not list them; the
   *  parent links to its hub, which does. */
  children?: SiteMapLink[];
};

export type SiteMapColumn = {
  heading: string;
  links: SiteMapLink[];
};

export const SITE_MAP: SiteMapColumn[] = [
  {
    heading: "Trust",
    links: [
      { label: "What trust is", href: "/trust" },
      { label: "The playground", href: "/trust#playground" },
      { label: "Trust Force Equation", href: "/learn/trust-force-equation" },
      { label: "Trust Tiers", href: "/learn/trust-tiers" },
    ],
  },
  {
    heading: "Learn",
    links: [
      { label: "Find your path", href: "/start" },
      {
        label: "Learning guide",
        href: "/learn",
        children: [
          { label: "Trust Tiers", href: "/learn/trust-tiers" },
          { label: "Lineage", href: "/learn/lineage" },
          { label: "Simulator\n(Dry Dock)", href: "/learn/simulator" },
        ],
      },
      { label: "The Constitution", href: "/learn/constitution" },
    ],
  },
  {
    heading: "Specs",
    links: [
      {
        label: "Architecture",
        href: "/specs",
        children: [
          { label: "Blue Zones", href: "/specs/blue-zones" },
        ],
      },
      { label: "Implement", href: "/implement" },
      { label: "Governed Autonomy", href: "/governed-autonomy" },
      {
        label: "RFC source",
        href: "https://github.com/nmcitra/ktp-rfc",
        external: true,
      },
      {
        label: "SDK source",
        href: "https://github.com/martherus/kinetic-trust",
        external: true,
      },
    ],
  },
  {
    heading: "Research",
    links: [
      {
        label: "Program",
        href: "/research",
        children: [
          { label: "Cartography", href: "/research/cartography" },
          { label: "Methods", href: "/research/methods" },
          { label: "Four Clocks", href: "/research/four-clocks" },
          { label: "Ambient Breach Theory", href: "/research/ambient-breach" },
          { label: "Falsification", href: "/research/falsification" },
          { label: "Shipwreck", href: "/research/shipwreck" },
          { label: "AI 2027", href: "/research/ai-2027" },
          { label: "Violence", href: "/research/violence" },
          { label: "Roadmap", href: "/research/roadmap" },
        ],
      },
      {
        label: "Cognitive",
        href: "/research/cognitive",
        children: [
          { label: "ACPP", href: "/research/cognitive/acpp" },
          {
            label: "Installed Watcher",
            href: "/research/cognitive/installed-watcher",
          },
          { label: "DCTI", href: "/research/cognitive/dcti" },
          { label: "The Diagnostic Ladder", href: "/research/cognitive/ladder" },
          { label: "Sources", href: "/research/cognitive/sources" },
        ],
      },
      // Applied campaign hubs — top-level routes (not /research/*),
      // surfaced here so the walks aren't direct-link-only.
      { label: "Bitcoin ↔ KTP", href: "/btc" },
      { label: "Disarm the Control Plane", href: "/disarm" },
      { label: "Enshittification", href: "/enshittification" },
    ],
  },
  {
    heading: "Canon",
    links: [
      {
        label: "Canon hub",
        href: "/canon",
        children: [
          { label: "Synthesis", href: "/canon/synthesis" },
          { label: "Clusters", href: "/canon/clusters" },
          { label: "Stack", href: "/canon/stack" },
          { label: "Claims", href: "/canon/claims" },
          { label: "Limits", href: "/canon/limits" },
          { label: "Glossary", href: "/canon/glossary" },
          { label: "Ancestors", href: "/canon/ancestors/stewart-brand" },
          { label: "Ethics", href: "/canon/ethics" },
          { label: "Repair", href: "/canon/repair" },
        ],
      },
      { label: "Glossary", href: "/canon/glossary" },
    ],
  },
  {
    heading: "Community",
    links: [
      { label: "About this work", href: "/about" },
      { label: "Writing", href: "/writing" },
      { label: "Advocacy", href: "/advocacy" },
      { label: "Language", href: "/language" },
      { label: "Community", href: "/community" },
    ],
  },
];

